const Reservation = () => {
    return ( <h1>Reservations list</h1> );
}
 
export default Reservation;